import React, { useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { ImSpinner2 } from "react-icons/im";
import { HouseContext } from "../../context/HouseContext";
import House from "../../components/House/House";
import { Helmet } from "react-helmet";

const PropertyType = () => {
  const { type } = useParams(); // Recibe el parámetro de tipo desde la URL
  const { allHouses, loading } = useContext(HouseContext);
  const [visibleHouses, setVisibleHouses] = useState(6); // Mostrar 6 casas inicialmente

  // Filtra sobre TODAS las propiedades (no sobre la lista ya filtrada por una
  // búsqueda previa). El parámetro puede ser una operación (Venta/Alquiler) o un
  // tipo (Terreno/Casa/...). Comparamos sin distinción de mayúsculas y tolerando
  // el plural (ej. "Terrenos" -> "Terreno").
  const houses = allHouses;
  const filteredHouses = type
    ? allHouses.filter((house) => {
        const t = type.toLowerCase();
        const tSingular = t.replace(/s$/, "");
        const st = (house.state || "").toLowerCase();
        const ty = (house.type || "").toLowerCase();
        return st === t || ty === t || ty === tSingular;
      })
    : allHouses;

  const showMoreHouses = () => {
    setVisibleHouses((prevVisibleHouses) => prevVisibleHouses + 6);
  };

  if (loading || houses.length === 0) {
    return (
      <div className="flex flex-col justify-center items-center h-screen">
        <ImSpinner2 className="animate-spin text-primary text-5xl mb-4" />
        <h2 className="text-primary text-2xl ml-4">Cargando Propiedades...</h2>
      </div>
    );
  }

  // Verificar si no hay casas después de que `houses` ya tiene datos
  if (!loading && houses.length > 0 && filteredHouses.length < 1) {
    return (
      <div className="text-center text-3xl text-gray-400 my-[200px]">
        Lo sentimos, no hemos encontrado resultados
      </div>
    );
  }

  return (
    <section className="my-32">
      <Helmet>
        <title>
          {type ? `Propiedades en ${type}` : "Todas las Propiedades"}
        </title>
        <meta
          name="description"
          content={`Explora las propiedades en ${
            type || "nuestra plataforma"
          } para encontrar la casa ideal. Verifica opciones de ${
            type || "tipos de propiedad"
          } disponibles.`}
        />
        <meta
          name="keywords"
          content={`propiedades, ${
            type ? type : "casas"
          }, alquiler, venta, compra, inmuebles`}
        />
      </Helmet>
      <div className="mx-auto max-w-[1360px] px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-14 justify-center">
          {filteredHouses.slice(0, visibleHouses).map((house, index) => (
            <Link to={`/propiedad/${house.id}`} key={index} className="block h-full">
              <House house={house} />
            </Link>
          ))}
        </div>
        {visibleHouses < filteredHouses.length && (
          <div className="text-center mt-8">
            <button
              onClick={showMoreHouses}
              className="bg-primary text-white px-4 py-2 rounded hover:opacity-80"
            >
              Ver más Propiedades
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default PropertyType;
